import axios from 'axios'
export default{
    getRegister(){
        return axios.get(process.env.VUE_APP_API+'/register');
    },
    saveRegister(data){
        return axios.post(process.env.VUE_APP_API+'/register', data);
    },

    // Company
    getCompanyActiveAll(){
        return axios.get(process.env.VUE_APP_API+'/company/active/all');
    },

    // Form
    getFormActiveAll(){
        return axios.get(process.env.VUE_APP_API+'/form/active/all');
    },
    getFormById(id){
        return axios.get(process.env.VUE_APP_API+'/form/id?id='+id);
    },
    updateFormWorking(token,data){
        const AuthStr = 'Bearer '.concat(token); 
        return axios.post(process.env.VUE_APP_API+'/form/working', data, { 
            headers: { 
                Authorization: AuthStr, 
                Accept: 'application/json'
            } 
        });
    },
    saveForm(token,data){
        const AuthStr = 'Bearer '.concat(token); 
        return axios.post(process.env.VUE_APP_API+'/form', data, { 
            headers: { 
                Authorization: AuthStr, 
                Accept: 'application/json'
            } 
        });
    },
    updateForm(token,data){
        const AuthStr = 'Bearer '.concat(token); 
        return axios.post(process.env.VUE_APP_API+'/form/update', data, { 
            headers: { 
                Authorization: AuthStr, 
                Accept: 'application/json'
            } 
        });
    },
    cancelForm(token,data){
        const AuthStr = 'Bearer '.concat(token); 
        return axios.post(process.env.VUE_APP_API+'/form/cancel', data, { 
            headers: { 
                Authorization: AuthStr, 
                Accept: 'application/json'
            } 
        });
    },

    // Question
    cancelQuestion(token,data){
        const AuthStr = 'Bearer '.concat(token); 
        return axios.post(process.env.VUE_APP_API+'/question/cancel', data, { 
            headers: { 
                Authorization: AuthStr, 
                Accept: 'application/json'
            } 
        });
    },

    // Choice
    cancelChoice(token,data){
        const AuthStr = 'Bearer '.concat(token); 
        return axios.post(process.env.VUE_APP_API+'/choice/cancel', data, { 
            headers: { 
                Authorization: AuthStr, 
                Accept: 'application/json'
            } 
        });
    },

    // ChoiceType
    getChoiceTypeActiveAll(){
        return axios.get(process.env.VUE_APP_API+'/choicetype/active/all');
    },

    // LineChannel
    getLineChannelActiveAll(){
        return axios.get(process.env.VUE_APP_API+'/linechannel/active/all');
    },
    saveLineChannel(token,data){
        const AuthStr = 'Bearer '.concat(token); 
        return axios.post(process.env.VUE_APP_API+'/linechannel', data, { 
            headers: { 
                Authorization: AuthStr, 
                Accept: 'application/json'
            } 
        });
    },
    updateLineChannel(token,data){
        const AuthStr = 'Bearer '.concat(token); 
        return axios.post(process.env.VUE_APP_API+'/linechannel/update', data, { 
            headers: { 
                Authorization: AuthStr, 
                Accept: 'application/json'
            } 
        });
    },
    cancelLineChannel(token,data){
        const AuthStr = 'Bearer '.concat(token); 
        return axios.post(process.env.VUE_APP_API+'/linechannel/cancel', data, { 
            headers: { 
                Authorization: AuthStr, 
                Accept: 'application/json'
            } 
        });
    },

    // Facebook pixel
    getFacebookPixelActiveAll(){
        return axios.get(process.env.VUE_APP_API+'/facebookpixel/active/all');
    },
    saveFacebookPixel(token,data){
        const AuthStr = 'Bearer '.concat(token); 
        return axios.post(process.env.VUE_APP_API+'/facebookpixel', data, { 
            headers: { 
                Authorization: AuthStr, 
                Accept: 'application/json'
            } 
        });
        // return axios.post(process.env.VUE_APP_API+'/facebookpixel', data);
    },
    updateFacebookPixel(token,data){
        const AuthStr = 'Bearer '.concat(token); 
        return axios.post(process.env.VUE_APP_API+'/facebookpixel/update', data, { 
            headers: { 
                Authorization: AuthStr, 
                Accept: 'application/json'
            } 
        });
        // return axios.put(process.env.VUE_APP_API+'/facebookpixel', data);
    },
    cancelFacebookPixel(token,data){
        const AuthStr = 'Bearer '.concat(token); 
        return axios.post(process.env.VUE_APP_API+'/facebookpixel/cancel', data, { 
            headers: { 
                Authorization: AuthStr, 
                Accept: 'application/json'
            } 
        });
        // return axios.delete(process.env.VUE_APP_API+'/facebookpixel', data);
    },

    // Thanks
    pathThanks(filepath){
        return process.env.VUE_APP_API+'/thanks/image?filepath='+filepath;
    },
    getThanksActive(){
        return axios.get(process.env.VUE_APP_API+'/thanks/active');
    },
    saveThanks(token,data){
        const AuthStr = 'Bearer '.concat(token); 
        return axios.post(process.env.VUE_APP_API+'/thanks', data, { 
            headers: { 
                Authorization: AuthStr, 
                Accept: 'application/json',
                'Content-Type': 'multipart/form-data'
            } 
        });
        // return axios.post(process.env.VUE_APP_API+'/thanks', data, {
        //     headers: { 'Content-Type': 'multipart/form-data' }
        // });
    },

    // Role
    getRoleActiveAll(){
        return axios.get(process.env.VUE_APP_API+'/role/active/all');
    },

    // User
    getUserActiveAll(){
        return axios.get(process.env.VUE_APP_API+'/user/active/all');
    },
    getAuth(token){
        const AuthStr = 'Bearer '.concat(token); 
        return axios.get(process.env.VUE_APP_API+'/user', { 
            headers: { 
                Authorization: AuthStr, 
                Accept: 'application/json'
            } 
        });
    },
    login(data){
        return axios.post(process.env.VUE_APP_API+'/user/login', data);
    },
    logout(token){
        const AuthStr = 'Bearer '.concat(token); 
        return axios.get(process.env.VUE_APP_API+'/user/logout', { 
            headers: { 
                Authorization: AuthStr, 
                Accept: 'application/json'
            } 
        });
    },
    saveUser(data){
        return axios.post(process.env.VUE_APP_API+'/user/signup', data);
    },
    updateUser(token,data){
        const AuthStr = 'Bearer '.concat(token); 
        return axios.post(process.env.VUE_APP_API+'/user/update', data, { 
            headers: { 
                Authorization: AuthStr, 
                Accept: 'application/json'
            } 
        });
    },
    cancelUser(token,data){
        const AuthStr = 'Bearer '.concat(token); 
        return axios.post(process.env.VUE_APP_API+'/user/cancel', data, { 
            headers: { 
                Authorization: AuthStr, 
                Accept: 'application/json'
            } 
        });
    },

    // Customer
    saveCustomer(data){
        return axios.post(process.env.VUE_APP_API+'/customer', data);
    },

    // Test
    getTest(){
        return axios.get(process.env.VUE_APP_API+'/test');
    },
}